import useMatchMedia from '@/hooks/useMatchMedia';
import PageHead from '@/components/common/PageHead';

//Custom component's
import ClientOnly from '@/components/common/ClientOnly';
import Container from '@/components/common/Container';
import Section from '@/components/common/Section';
import Heading from '@/components/common/Heading';
import Box from '@/components/common/Box/Box';

import servicesMeta from '@/db/services/servicesMeta.json';
import ServicesLayout from '@/components/Pages/Services/ServicesLayout';
import ServicesFeature from '@/components/Pages/Services/ServicesFeatures';
import ServicesInfo from '@/components/Pages/Services/ServicesInfo';
import FAQs from '@/components/Pages/Index/FAQs';
import InnerHero from '@/components/InnerHero';
import BackgroundHero from '@/components/common/Background/BackgroundHero';

import servicesFeatures from '@/db/services/servicesFeatures.json';
import servicesInfo from '@/db/services/servicesInfo.json';
import faqs from '@/db/services/faqsServices.json';
import innerHero from '@/db/services/servicesHero.json';

const Services = () => {
  const { isMobile } = useMatchMedia();
  return (
    <>
      <PageHead {...servicesMeta} />

      <Box className=" relative">
        <Container>
          <Section className="pt-0 pb-0 lg:pb-4">
            <InnerHero innerHero={innerHero} />
          </Section>
        </Container>
        <BackgroundHero />
      </Box>

      <Container>
        <Section>
          <ServicesFeature servicesFeatures={servicesFeatures} />
        </Section>
      </Container>

      <Container>
        <Section>
          <Heading headingLevel="h2" className="text-center mb-[40px]">
            Find Solutions for Your Needs
          </Heading>
          <ServicesInfo servicesInfo={servicesInfo} />
        </Section>
      </Container>

      <Container>
        <Section>
          <Heading headingLevel="h2" className="text-center mb-5 md:mb-16">
            <ClientOnly>
              {isMobile
                ? 'FAQs'
                : 'Frequently Asked Questions about Our Services'}
            </ClientOnly>
          </Heading>
          <FAQs faqs={faqs} />
        </Section>
      </Container>
    </>
  );
};

Services.PageLayout = ServicesLayout;

export default Services;
